export default {
  //TODO: REMOVE AND USE NEW TRANSLATIONS
  AV_SETTINGS: `Audio and Video Settings`,
  AV_PREVIEW: `Audio & Video Preview`,
  SPEAKER_TEST: `Speaker Test`,
  SPEAKER_TEST_HELP_TEXT: `We'll send a sound to check your speaker/headphones. Make sure the volume is up.`,
  SPEAKER_TEST_CTA: `Test your speakers`,
  CHOOSE_DEVICES_HEADER: `Choose the camera, microphone, and speaker / headphones for this call:`,
  MIC_INPUT_LABEL: `Microphone`,
  VIDEO_INPUT_LABEL: `Video`,
  MICROPHONE_SOUND_LEVEL: `Microphone sound level`,
  CLOSE: `Close`,
  NONE: `None`,

  // NEW TRANSLATIONS
  DEVICE_SETTINGS_MODAL_HEADER: `Settings`,
  DEVICE_SETTINGS_TAB_SETTINGS: `Device Settings`,
  DEVICE_SETTINGS_TAB_HELP: `Help`,
  DEVICE_SETTINGS_SPEAKER_SELECTION_LABEL: `Select your speakers`,
  DEVICE_SETTINGS_SPEAKER_TEST_BUTTON: `Test Your Speakers`,
  DEVICE_SETTINGS_MICROPHONE_SELECTION_LABEL: `Select your microphone`,
  DEVICE_SETTINGS_CAMERA_SELECTION_LABEL: `Select your camera`,
  DEVICE_SETTINGS_BACK_TO_CALL_BUTTON: `Go Back to Call`,
  DEVICE_SETTINGS_HELP_BUTTON: `I Need Help`,

  DEVICE_SETTINGS_DROPDOWN_ERROR_PLACEHOLDER: `- Select -`,
  DEVICE_SETTINGS_SPEAKER_ERROR_ALERT: `Select a speaker to proceed.`,
  DEVICE_SETTINGS_MICROPHONE_ERROR_ALERT: `Select a microphone to proceed.`,
  DEVICE_SETTINGS_CAMERA_ERROR_ALERT: `Select a camera input to proceed.`,

  DEVICE_SETTINGS_AUDIO_ONLY_OPTION_FOR_CAMERA_DROPDOWN: `Join call via audio only`,
  DEVICE_SETTINGS_SAFARI_SPEAKER_ERROR_ALERT: `Select a different speaker to proceed.`,
  DEVICE_SETTINGS_DROPDOWN_AUTO_DETECTED: `- Auto-detected -`,

  PICK_SOUND_OUTPUT_DEVICE: `Pick Sound Output Device`,
  CHOOSE_YOUR_CAMERA: `Pick Camera Input Device`,
  CHOOSE_YOUR_MICROPHONE: `Pick Microphone Input Device`,

  DEVICE_SETTINGS_DEFAULT: `Default`,
  DEVICE_SETTINGS_VIDEO_QUALITY: `Video Quality`,

  // footer
  FOOTER_A11Y_STATEMENT: `Accessibility Statement`,
};
